import React, { useEffect, useState } from "react";
import GroupActivityButton from "../groups/ui/GroupActivityButton";
import { format, formatDistance, parseISO } from "date-fns";
import { getSessionDetailsById } from "../../services/ActivePrograms";
import { Checkbox } from "@mui/material";
import "./style.css";
import { IoArrowBack, IoEyeOutline, IoShareSocial } from "react-icons/io5";
import { MdDownloadForOffline } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import moment from "moment";
import { FaClock } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { ReactComponent as NoData} from "../../svg/NoAnyData.svg";
import { Modal, Button } from "react-bootstrap";

import ChartCapture from "./ChartCapture";
import GroupChartCapture from "./GroupChartCapture";

const IndividualNoteItem = ({ member, handleEdit, handleDetails, state, isSelected, onSelect  }) => {
  const isComplete = member.status;
  const [downloadPDF, setDownloadPDF] = useState(false);

  const handleCheckboxChange = (e) => {
    onSelect(member, e.target.checked);
  };
  return (
    <div className="d-flex gap-2 align-items-center mt-4">
      <Checkbox
        size="medium"
        checked={isSelected}
        onChange={handleCheckboxChange}
        sx={{
          color: "rgba(31, 126, 120, 1)",
          "&.Mui-checked": {
            color: "rgba(31, 126, 120, 1)",
          },
        }}
      />
      <div
        className={
          "card w-100 border-0 session-notes-card " +
          (isComplete ? "complete-note-card" : "incomplete-note-card")
        }
      >
        {downloadPDF && (
          <ChartCapture
            setDownloadPDF={setDownloadPDF}
            downloadPDF={downloadPDF}
            state={state}
            member={member}
          />
        )}
        <div className="card-body py-2">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 ">
              <img
                src={
                  member.userprofilePicture
                    ? member.userprofilePicture
                    : "images/avatar.png"
                }
                onError={(e) => (e.target.src = "images/avatar.png")}
                alt="not rendered"
                className="rounded-circle individual-notes-img"
                height={45}
              />
              <h6 className="fw-semibold mb-0 individual-notes-title">
                {member?.userName}
              </h6>
            </div>
            <div className="d-flex align-items-center gap-3">
              <span>{member?.gender}</span> |<span>{member?.dob}</span> |
              <span>{moment().diff(new Date(member?.dob), "years")} Yrs</span> |
              <span>{member?.city}</span>
            </div>
            <div>
              <button className="btn btn-sm" onClick={() => handleEdit(member)}>
                <AiFillEdit color="#1F7E78" size={18} />
              </button>
              {/* <SessionNotePDF /> */}
              <button
                className="btn btn-sm"
                onClick={() => handleDetails(member)}
              >
                <IoEyeOutline color="#1F7E78" size={18} />
              </button>
              <button
                className="btn btn-sm border-0"
                disabled={!isComplete}
                onClick={() => setDownloadPDF(true)}
              >
                <MdDownloadForOffline
                  color={isComplete ? "#1F7E78" : "#B3B5BE"}
                  size={18}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function ViewSessionNotes({ setViewMode, state, setMember }) {
  const [sessionDetails, setSessionDetails] = useState({});
  const [isLoading, setLoader] = useState(true);
  const [duration, setDuration] = useState("");
  const [members, setMembers] = useState([]);
  const [filterMembers, setFilterMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadPDF, setDownloadPDF] = useState(false);
  const [downloadGroupPDF, setDownloadGroupPDF] = useState(false);
  const [session, setSession] = useState(state);

  const getSessionDetails = async () => {
    try {
      const res = await getSessionDetailsById(state?._id);
      console.log(res?.data?.data);
      setSessionDetails(res?.data?.data);
      setMembers(res?.data?.data?.programMemerDetails??[])
      setFilterMembers(res?.data?.data?.programMemerDetails??[])
      setSession(res?.data?.data?.session);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSessionDetails();
  }, []);

  const handleSearchMembers = (e) => {
    const filter = members.filter((item)=>item.userName.toLowerCase().includes(e.target.value))
    setFilterMembers(filter)
  };
  const getDuration = () => {
    const dur =
      state?.startTime &&
      state?.endTime &&
      formatDistance(parseISO(state.endTime), parseISO(state.startTime));
      const diff = new Date(state.endTime) - new Date(state.startTime);
    setDuration(Math.floor(diff / 60000)+" minutes");
  };
  useEffect(() => {
    getDuration();
  }, []);

  const handleEdit = (member) => {
    setViewMode("sessionNoteEdit");
    setMember(member);
  };
  const handleDetails = (member) => {
    setViewMode("sessionNoteDetails");
    setMember(member);
  };

  const handleMemberSelection = (member, isSelected) => {
    setSelectedMembers(prev => {
      if (isSelected) {
        return [...prev, member];
      } else {
        return prev.filter(m => m.user_id !== member.user_id);
      }
    });
  };

  const handleDownloadNotes = () => {
    if (selectedMembers.length === 0) {
      alert("Please select at least one member to download notes");
      return;
    }
    setShowDownloadModal(true);
  };

  const handleDownloadConfirm = async (singleFile) => {
    setShowDownloadModal(false);
    
    // Find the selected members
    const membersToDownload = filterMembers.filter((member) =>
      selectedMembers.some(m => m.user_id === member.user_id)
    );

    if (singleFile) {
      // For single file, we'll need to create a combined PDF
      // This would require modifying the SessionNotePDF component to handle multiple members
      // For now, we'll trigger individual downloads sequentially
      for (const member of membersToDownload) {
        setMember(member);
        setDownloadPDF(true);
        // Wait for PDF generation to complete before moving to next member
        await new Promise(resolve => setTimeout(resolve, 2000));
      }
    } else {
      // For multiple files, trigger individual downloads
      membersToDownload.forEach((member, index) => {
        setTimeout(() => {
          setMember(member);
          setDownloadPDF(true);
        }, index * 2000); // Add delay between downloads
      });
    }
  };

  return (
    <div className="row column-gap-5">
      <div className="d-flex mt-2">
        <button
          className="btn btn-primary btn-custom-tag py-2 "
          onClick={() => setViewMode(null)}
        >
          <IoArrowBack /> &nbsp;&nbsp;&nbsp; Back
        </button>
      </div>
      <div className="d-flex gap-5 mt-4">
        <div className="d-flex align-items-center note-search-box w-100">
          <FiSearch className="boxicon" />
          <input
            type="text"
            className="p-2 w-100 border-0"
            name="title"
            onChange={(e) => handleSearchMembers(e)}
            placeholder="Search Member"
          />
        </div>
        <GroupActivityButton
          padding="5px 15px"
          className="rounded"
          fontWeight="500"
          width="250px"
          backgroundColor="rgba(47, 156, 149, 1)"
          border="none"
          color="rgb(255, 255, 255)"
          onClick={handleDownloadNotes}
        >
          Download Notes <MdDownloadForOffline />
        </GroupActivityButton>
      </div>

      <div className="mt-4">
        <h6 className="fw-bold"> Group Note</h6>
        <div className="d-flex gap-2 align-items-center mt-4">
          <Checkbox
            size="medium"
            sx={{
              color: "rgba(31, 126, 120, 1)",
              "&.Mui-checked": {
                color: "rgba(31, 126, 120, 1)",
              },
            }}
          />
           {downloadGroupPDF && (
            <GroupChartCapture
              setDownloadPDF={setDownloadGroupPDF}
              downloadPDF={downloadGroupPDF}
              state={state}
            />
          )}
          <div className="card w-100 border-0 session-notes-card">
            <div className="card-body pt-1">
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="fst-italic m-0 p-0"> 
                {sessionDetails?.groupSessionStatus == "completed"?"Completed":"Incomplete"}
                </h6>
                <div>
                  <button
                    className="btn btn-sm"
                    onClick={() => setViewMode("sessionGroupNoteEdit")}
                  >
                    <AiFillEdit color="#1F7E78" size={18} />
                  </button>
                  <button className="btn btn-sm" onClick={() => setViewMode("sessionGroupNoteDetails")}>
                    <IoEyeOutline color="#1F7E78" size={18} />
                  </button>
                  <button onClick={() => setDownloadGroupPDF(true)} className="btn btn-sm border-0" disabled={sessionDetails?.groupSessionStatus != "completed"}>
                    <MdDownloadForOffline color={sessionDetails?.groupSessionStatus == "completed"?"#1F7E78":"#B3B5BE"} size={18} />
                  </button>
                </div>
              </div>
              <div className=" mt-3 d-flex align-items-center justify-content-between">
                <div>
                  <h5 className="fw-normal">
                    {session?.sessionDate &&
                      moment(new Date(session?.sessionDate)).format(
                        "dddd MMM DD yyyy"
                      )}
                  </h5>
                  <h4 className="fw-semibold mt-3">{session.title}</h4>
                </div>
                <div className="mb-2">
                  <h5 className="fw-normal d-flex align-items-center justify-content-end">
                    <FaClock
                      style={{ color: "rgba(31, 126, 120, 1)" }}
                      className="me-2 "
                      size={"17px"}
                    />
                    {session?.startTime &&
                      format(parseISO(session?.startTime), "HH:mm")}{" "}
                    CST
                  </h5>
                  <h5 className="fw-normal mt-3">Duration : {duration}</h5>
                </div>
              </div>
              <p>{session?.description}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 pt-2">
        <h6 className="fw-bold "> Individual Notes</h6>
        <div>
          {isLoading ? (
            <center>
              <div className="spinner-border mt-3 mb-4" role="status" />
            </center>
          ) : filterMembers.length > 0 ? (
            filterMembers.map((member) => (
              <IndividualNoteItem
                key={member.user_id}
                member={member}
                handleEdit={handleEdit}
                handleDetails={handleDetails}
                state={session}
                isSelected={selectedMembers.some(m => m.user_id === member.user_id)}
                onSelect={handleMemberSelection}
                downloadPDF={downloadPDF}
                setDownloadPDF={setDownloadPDF}
              />
            ))
          ) : (
            <center><NoData style={{maxWidth:800}}/></center>
          )}
        </div>
      </div>

      {/* Download Modal */}
      <Modal show={showDownloadModal} onHide={() => setShowDownloadModal(false)} centered>
        <Modal.Header closeButton>
          {/* <Modal.Title>Download Options</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <p className="text-center fw-bold">How do you want the notes downloaded?</p>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button 
              variant="primary" 
              onClick={() => handleDownloadConfirm(true)}
              style={{ backgroundColor: "#1F7E78", borderColor: "#1F7E78" }}
            >
              Single File
            </Button>
            <Button 
              variant="secondary" 
              onClick={() => handleDownloadConfirm(false)}
              style={{ backgroundColor: "#1F7E78", borderColor: "#6c757d" }}
            >
              Multiple Files
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ViewSessionNotes;
